import { takeLast } from "ramda";

export default function generateRandomId() {
  const randomNumber = window.crypto.getRandomValues(new Uint32Array(1));
  return takeLast(5, randomNumber[0].toString(36));
}
